{
  "account": {
    "title": "मेरा खाता",
    "list": {
      "title": "खाते",
      "description": "लिंक्ड खातों की चलाने वाली सूची"
    },
    "form": {
      "name": {
        "title": "नाम",
        "description": "आपका खाता नाम"
      },
      "password": {
        "title": "पासवर्ड",
        "description": "अपने खाते के लिए नया पासवर्ड सेट करें, मौजूदा पासवर्ड रखने के लिए खाली छोड़ें"
      },
      "emailPreferences": {
        "title": "ईमेल प्राथमिकताएँ",
        "description": "ईमेल सूचना प्रकार चुनें"
      }
    },
    "billing": "बिलिंग विवरण",
    "subscriptions": "सदस्यताएँ",
    "manageSubscription": "सदस्यता प्रबंधित करें",
    "popup": {
      "cancel": "क्या आप वाकई अपनी सदस्यता रद्द करना चाहते हैं?<br/>आपकी वेबसाइट अनुवाद तब तक जारी रहेगा जब तक आपकी मौजूदा सदस्यता अवधि समाप्त नहीं हो जाती। उसके बाद अनुवाद अक्षम कर दिया जाएगा।<br/>कृपया ध्यान दें कि अप्रयुक्त अवधि के लिए कोई छूट योग्य नहीं होगी।",
      "downgrade": "क्या आप वाकई डाउनग्रेड करना चाहते हैं? डाउनग्रेड तुरंत प्रभावी हो जाएगा।<br/>कृपया ध्यान दें कि मौजूदा बिलिंग चक्र की शेष अवधि के लिए कोई छूट योग्य नहीं होगी।<br/>नई योजना की कीमत अगले बिलिंग चक्र में लागू होगी।",
      "default": "क्या आप वाकई अपनी योजना बदलना चाहते हैं?",
      "resume": "क्या आप अपनी सदस्यता फिर से शुरू करने के लिए निश्चित हैं?"
    }
  },
  "ai_translation": {
    "header": "एआई अनुवाद",
    "plan": {
      "header": "एआई अनुवाद मूल्य निर्धारण",
      "used": "आपने अपने एआई क्रेडिट्स में {words_used} / {words_allowed} अनुवादित शब्दों का उपयोग किया है।",
      "remaining": "उपलब्ध एआई क्रेडिट्स:",
      "words": "शब्द",
      "add_more_credits": "अधिक एआई क्रेडिट्स जोड़ें",
      "details": {
        "idiomatic_expressions": "मुहावरेदार और तकनीकी अभिव्यक्तियाँ",
        "background_translation": "बैकग्राउंड में अनुवाद",
        "best_website": "वेबसाइट जिसे परिपूर्ण अनुवाद गुणवत्ता की आवश्यकता है",
        "page_context": "पृष्ठ और वेबसाइट संदर्भ के लिए अनुवाद",
        "perfect_quality": "पूर्ण गुणवत्ता, किफायती मूल्य",
        "no_recurring": "कोई आवर्ती भुगतान नहीं, प्री-पेड कोटा",
        "save_40": "$20 योजना की तुलना में 40% बचत करें",
        "save_50": "$20 योजना की तुलना में 50% बचत करें"
      },
      "quota": "{estimated_words} शब्द ~ {estimated_pages} पृष्ठ"
    },
    "settings": {
      "banner": {
        "title": "Linguise एआई अनुवाद",
        "intro": "Linguise Linguise AI Translation का अनावरण करते हुए उत्साहित है, एक नया प्रीमियम सुविधा जो AI LLM मॉडल्स (अनुवाद कार्यों के लिए अनुकूलित সबसे हाल के Llama मॉडल) का लाभ उठाती है। परिपूर्ण शुद्धता की मांग करने वाली वेबसाइट्स के लिए डिज़ाइन की गई है, यह पृष्ठ और संपूर्ण वेबसाइट संदर्भ दोनों को ध्यान में रखती है। अपने ग्राहकों को अनुवाद गुणवत्ता की पराकाष्ठा प्रदान करें, यह सुनिश्चित करते हुए कि उनका संदेश हर भाषा में पूर्णतः गूंजता है।",
        "button": "अभी अपग्रेड करें"
      },
      "alert": {
        "description": "यह सुविधा आपकी मौजूदा योजना में शामिल नहीं है और इसके लिए अलग से खरीदारी की आवश्यकता है।\nनीचे सूचीबद्ध सभी विकल्पों को अनलॉक करने के लिए इस ऐड-ऑन को सक्रिय करें।"
      },
      "languages": {
        "title": "भाषाओं पर एआई अनुवाद लागू करें",
        "description": "विशिष्ट भाषा चुनें जहाँ आप एआई अनुवाद लागू करना चाहते हैं"
      },
      "button": {
        "save": "सेटिंग्स सहेजें"
      },
      "form": {
        "advanced": {
          "title": "उन्नत एआई निर्देश",
          "description": "उन्नत एआई निर्देश"
        },
        "enable_mode": {
          "title": "एआई अनुवाद सक्षम करें",
          "description": "चुनें कि आप एआई अनुवाद को कैसे सक्षम करना चाहते हैं।\nकेवल नियम निम्नलिखित नियमों को लागू करेंगे।\nकेवल लाइव एडिटर पृष्ठ-दर-पृष्ठ अनुवाद को लाइव एडिटर दृश्य से सक्षम करने की अनुमति देगा।\nनियम और लाइव एडिटर दोनों सुविधाओं का उपयोग करेंगे।",
          "disabled": "अक्षम",
          "rules": "केवल नियम",
          "live_editor": "केवल लाइव एडिटर",
          "all": "नियम और लाइव एडिटर"
        },
        "rule_application": {
          "description": "स्थिर सामग्री या गतिशील सामग्री या दोनों पर एआई अनुवाद लागू करें",
          "title": "सामग्री पर लागू करें",
          "all": "सभी सामग्री",
          "static": "स्थिर सामग्री",
          "dynamic": "गतिशील सामग्री"
        },
        "website_topic": {
          "title": "वेबसाइट विषय",
          "placeholder": "सुशी रेस्तरां...",
          "description": "बेहतर अनुवाद गुणवत्ता के लिए अपनी वेबसाइट का विषय परिभाषित करें (उदा. कानूनी, सुशी रेस्तरां, बाइक पुर्जे ई-शॉप…)\nकृपया वेबसाइट विषय को अंग्रेज़ी में दर्ज करें।"
        },
        "apply_to_urls": {
          "title": "यूआरएल पर लागू करें",
          "description": "विशिष्ट यूआरएल चुनें जहाँ आप एआई अनुवाद लागू करना चाहते हैं",
          "all_urls": "सभी यूआरएल",
          "selected_urls": "चयनित यूआरएल",
          "label": "लागू करने के लिए यूआरएल",
          "placeholder": "लागू करने के लिए यूआरएल",
          "wildcard": "वाइल्डकार्ड",
          "regex": "रेगुलर एक्सप्रेशन",
          "add": "नया जोड़ें",
          "expression": "एक्सप्रेशन प्रकार"
        },
        "apply_languages": {
          "title": "भाषाओं पर लागू करें",
          "description": "विशिष्ट भाषा चुनें जहाँ आप एआई अनुवाद लागू करना चाहते हैं",
          "all_languages": "सभी भाषाएँ",
          "selected_languages": "चयनित भाषाएँ",
          "placeholder": "भाषाएँ चुनें...",
          "feedback": "आपको एक भाषा चुनना होगा"
        },
        "formality": {
          "title": "औपचारिकता",
          "description": "अनुवादों में औपचारिकता की डिग्री निर्दिष्ट करें, संभावित रूप से दर्शकों और संदर्भों के लिए महत्वपूर्ण।\n\"तटस्थ\" मूल सामग्री की औपचारिकता को संरक्षित करने का प्रयास करेगा।\n\"औपचारिक\" पेशेवर, व्यापार या कानूनी सामग्री के लिए है (जैसे स्पेनिश में \"usted\" का उपयोग करना)।\n\"अनौपचारिक\" आकस्मिक, संवादात्मक सामग्री के लिए है (जैसे स्पेनिश में \"tú\" का उपयोग करना)।",
          "neutral": "तटस्थ",
          "formal": "औपचारिक",
          "informal": "अनौपचारिक"
        },
        "sentence_structure": {
          "classic": "क्लासिक",
          "short": "छोटे और तेज़ वाक्य",
          "detailed": "विस्तृत और व्याख्यात्मक वाक्य",
          "title": "वाक्य संरचना",
          "description": "लेखन शैली प्राथमिकता को परिभाषित करें।"
        },
        "content_purpose": {
          "marketing": "मार्केटिंग/प्रचार (प्रेरक, आकर्षक टोन)",
          "technical": "तकनीकी/निर्देशात्मक (स्पष्ट, सटीक, कार्य-उन्मुख)",
          "support": "ग्राहक सहायता (सहानुभूतिपूर्ण, मददगार, आश्वस्त करने वाला)",
          "legal": "कानूनी/अनुपालन (सटीक, औपचारिक, स्पष्ट)",
          "educational": "शैक्षिक (स्पष्ट, संरचित, सुलभ)",
          "other": "अन्य (अंग्रेज़ी में)",
          "title": "सामग्री उद्देश्य",
          "description": "अनुवाद की जा रही सामग्री के कार्यात्मक उद्देश्य को परिभाषित करें।",
          "other_placeholder": "उद्देश्य का वर्णन करें..."
        },
        "target_audience": {
          "title": "लक्षित दर्शक",
          "description": "अनुदित सामग्री के इच्छित दर्शकों की विशिष्टता (अंग्रेज़ी में)।",
          "placeholder": "उदाहरण के लिए, स्पेनिश भाषी माता-पिता, यूरोपीय संघ के गोपनीयता अधिकारी"
        },
        "override_default_translations": {
          "title": "डिफ़ॉल्ट अनुवाद को ओवरराइड करें",
          "description": "यदि हाँ पर सेट किया गया है तो यह विकल्प सामग्री को AI (Linguise AI) से अनुवादित करने के लिए मजबूर करेगा, भले ही वह पहले से ही क्लाउड AI अनुवाद (डिफ़ॉल्ट अनुवाद मॉडल) द्वारा अनुदित हो चुकी हो।"
        },
        "force_replace_before": {
          "title": "AI से दोबारा अनुवाद करने के लिए बाध्य करें",
          "description": "चुनी गई तारीख से पहले AI द्वारा अनुवादित किसी भी सामग्री का AI से फिर अनुवाद करें — उदाहरण के लिए, पुराने मॉडल से अनुवादित सामग्री। नियमों के अनुसार लागू पृष्ठों की अगली विज़िट पर फिर अनुवाद होगा और आपके AI क्रेडिट का उपयोग करेगा।",
          "before_date": "तारीख से पहले"
        },
        "model": {
          "current": "वर्तमान",
          "title": "मॉडल",
          "description": "वह LLM अनुवाद मॉडल चुनें जिसका आप उपयोग करना चाहते हैं",
          "load_error": "उपलब्ध मॉडल लोड नहीं हो सके। कृपया बाद में पुनः प्रयास करें।",
          "thinking_warning": "यह मॉडल उच्च स्तर के तर्क (\"सोच\") का उपयोग करता है और प्रति अनुवाद काफी अधिक टोकन खर्च करेगा।"
        },
        "override_manual_and_selected": {
          "no_default": "नहीं (डिफ़ॉल्ट)",
          "title": "मैन्युअल और चयनित अनुवादों को ओवरराइड करें",
          "description": "डिफ़ॉल्ट रूप से, आपके द्वारा मैन्युअल रूप से संपादित अनुवाद हमेशा आपकी वेबसाइट पर बना रहता है, भले ही एआई से बेहतर बनाया गया अनुवाद तैयार हो जाए। इसके बजाय एआई से बेहतर बनाया गया अनुवाद दिखाने के लिए हाँ चुनें। आपके मैन्युअल अनुवाद सुरक्षित रहते हैं और आप कभी भी वापस बदल सकते हैं। यह तब भी लागू होता है जब आप नए अनुवाद पाने के लिए पृष्ठों का फिर से अनुवाद करते हैं; उस समय नवीनतम अनुवाद अपने आप इस्तेमाल किया जाएगा।"
        }
      },
      "message": {
        "save_success": "वर्तमान पहले से अनुदित सामग्री से, उन पृष्ठों की संख्या जिन्हें AI अनुवाद से बेहतर बनाया जाएगा लगभग {{ai_affected_urls}} है।",
        "save_success_only": "सेटिंग्स सफलतापूर्वक सहेजी गईं।"
      }
    },
    "pricing": {
      "plan": {
        "title": "AI अनुवाद कोटा ऑर्डर करें",
        "buy_button": "AI अनुवाद पैकेज खरीदें"
      },
      "modal": {
        "title": "योजना परिवर्तन की पुष्टि करें",
        "description": "क्या आप वाकई अपनी AI अनुवाद योजना बदलना चाहते हैं?",
        "button_cancel": "रद्द करें",
        "button_confirm": "पुष्टि करें",
        "loading": "कृपया प्रतीक्षा करें...",
        "amount": "राशि",
        "credit": "क्रेडिट",
        "total_due": "कुल देय"
      },
      "comparison": {
        "title": "Google Cloud AI अनुवाद\nबनाम Linguise AI अनुवाद",
        "list": {
          "0": {
            "google": "तेज़ और भरोसेमंद अनुवाद",
            "linguise": "मुहावरेदार और तकनीकी अभिव्यक्तियों को संभालें"
          },
          "1": {
            "google": "वेबसाइट के सभी पन्नों का त्वरित अनुवाद",
            "linguise": "पृष्ठभूमि में अनुवाद का निर्माण"
          },
          "2": {
            "google": "सर्वोत्तम गुणवत्ता, कम कीमत",
            "linguise": "बिल्कुल सही गुणवत्ता, सस्ती कीमत"
          },
          "3": {
            "google": "बड़ी वेबसाइटों या कम बजट के लिए सर्वोत्तम",
            "linguise": "पूर्ण अनुवाद गुणवत्ता चाहने वाली वेबसाइट के लिए सर्वोत्तम"
          },
          "4": {
            "google": "अनुवाद के लिए पृष्ठ संदर्भ",
            "linguise": "अनुवाद के लिए पृष्ठ और वेबसाइट संदर्भ"
          }
        }
      },
      "botom_banner": {
        "title": "अद्वितीय अनुवाद सटीकता का अनुभव करें",
        "sub_title": "नए Linguise AI अनुवाद के साथ",
        "description": "Linguise अपने स्वचालित अनुवाद सेवाओं को Linguise AI अनुवाद के परिचय से बेहतर बना रहा है, एक शक्तिशाली नया विकल्प जो अत्याधुनिक AI अनुवाद LLM (अनुवादों के लिए अनुकूलित सबसे हाल के लामा मॉडल) का उपयोग करता है। यह अतिरिक्त वेबसाइट डेवलपर्स और वेब एजेंसियों को उच्चतम स्तर की अनुवाद गुणवत्ता प्रदान करता है, जो परियोजनाओं के लिए आदर्श है जहाँ पूर्णता अत्यंत आवश्यक है। Linguise AI अनुवाद हमारी मौजूदा, उच्च-गुणवत्ता वाली Google Cloud AI अनुवाद सेवा की पूरक करता है, आपको अधिक लचीलापन और सटीकता प्रदान करता है।"
      }
    },
    "success": {
      "tab_title": "AI अनुवाद योजना खरीदने के लिए धन्यवाद!",
      "title": "AI अनुवाद योजना खरीदने के लिए धन्यवाद!",
      "subtitle": "आपकी AI अनुवाद योजना सफलतापूर्वक खरीद ली गई है!",
      "message": "आप AI Translation सेटिंग्स पृष्ठ में अपनी AI अनुवाद योजना प्रबंधित कर सकते हैं।",
      "home": "AI अनुवाद प्रबंधित करें"
    }
  },
  "billing": {
    "form": {
      "name": {
        "title": "नाम",
        "description": "बिलिंग खाता नाम"
      },
      "phone": {
        "title": "फ़ोन",
        "description": "बिलिंग खाता फ़ोन"
      },
      "email": {
        "title": "ईमेल",
        "description": "बिलिंग खाता ईमेल"
      },
      "address": {
        "title": "पता",
        "description": "बिलिंग खाता पता",
        "city": "शहर",
        "country": "देश",
        "address1": "पता 1",
        "address2": "पता 2",
        "postal": "डाक कोड",
        "state": "राज्य"
      },
      "tax": {
        "title": "कर संख्या"
      }
    }
  },
  "checkouts": {
    "header": "चेकआउट",
    "payment_method": "भुगतान विधि चुनें",
    "stripe_card": "क्रेडिट कार्ड (Stripe)",
    "paypal": "PayPal",
    "address": {
      "new": "नया बिलिंग पता दर्ज करें",
      "existing": "मौजूदा पता उपयोग करें"
    },
    "pay_stripe": "पुष्टि करें और भुगतान करें",
    "terms": "अपनी सदस्यता की पुष्टि करके, आप Linguise को हमारी शर्तों के अनुसार भविष्य के भुगतानों के लिए शुल्क लेने की अनुमति देते हैं। आप कभी भी अपनी सदस्यता रद्द कर सकते हैं।",
    "coupon": {
      "title": "कूपन है?",
      "placeholder": "अपना कूपन कोड यहाँ डालें",
      "apply": "लागू करें",
      "percent": "{{0}}% की छूट"
    },
    "add_new": "नया जोड़ें",
    "use_existing": "मौजूदा भुगतान विधि उपयोग करें",
    "recurring": {
      "month_single": "मासिक बिलिंग",
      "month_many": "हर {{count}} महीने बिलिंग",
      "year_single": "वार्षिक बिलिंग",
      "year_many": "हर {{count}} वर्ष बिलिंग",
      "day_single": "दैनिक बिलिंग",
      "day_many": "हर {{count}} दिन बिलिंग",
      "week_single": "साप्ताहिक बिलिंग",
      "week_many": "हर {{count}} सप्ताह बिलिंग"
    },
    "add_new_no_stripe": "नया कार्ड जोड़ें",
    "summary": {
      "title": "सारांश",
      "subtotal": "उपयोग",
      "total": "कुल"
    }
  },
  "dashboard": {
    "main": {
      "title": "डैशबोर्ड"
    },
    "statistics": {
      "main_title": "पिछले 30 दिन का आँकड़ा",
      "characters": "अनुवादित अक्षर",
      "words": "अनुवादित शब्द",
      "bandwidth": "इनपुट बैंडविड्थ",
      "request": "अनुरोध",
      "page_views": "प्रति भाषा पेज़ विचार (पिछले 30 दिन)",
      "multilingual_views": "बहुभाषी पेज विचार (पिछले 30 दिन)",
      "most_page_viewed": "20 सबसे अधिक देखे गए पृष्ठ (पिछले 30 दिन)",
      "no_data_yet": "अभी कोई डेटा उपलब्ध नहीं है",
      "th_language": "भाषा",
      "th_page_views": "पेज विचार",
      "real_visitors": "वास्तविक आगंतुक",
      "crawler": "वेब क्रॉलर"
    },
    "planHints": {
      "subscribeButton": "सदस्यता लें",
      "upgradeButton": "अपग्रेड करें",
      "usedWords": "आप वर्तमान में {words_used} शब्द हैं",
      "noPlan": "इस डोमेन के लिए कोई योजना सक्रिय नहीं है। एक योजना की सदस्यता लें और अपनी वेबसाइट का अनुवाद शुरू करें",
      "noPlanShopify": "इस डोमेन के लिए कोई योजना सक्रिय नहीं है। अपने Shopify डैशबोर्ड में एक योजना की सदस्यता लें और अपनी वेबसाइट का अनुवाद शुरू करें",
      "trialUsage": "आप वर्तमान में {words_allowed} शब्द वाली परीक्षण योजना में {words_used} शब्द उपयोग कर रहे हैं।",
      "trialEnds": "पहला महीना परीक्षण तब तक सक्रिय है जब तक {trial_ends}.",
      "subscribeMessage": "समाप्त होने से पहले सदस्यता लें ताकि आपकी वेबसाइट अनुवादित रहे",
      "subscribeMessageShopify": "अपने Shopify डैशबोर्ड से समाप्त होने से पहले सदस्यता लें ताकि आपकी वेबसाइट अनुवादित रहे",
      "trialReachedLimit": "आप परीक्षण अवधि की अधिकतम अनुवादित शब्द सीमा तक पहुँच गए हैं।\nआप अपनी वेबसाइट का अनुवाद जारी रखने के लिए हमारी किसी योजना की सदस्यता लें।",
      "paidUsage": "आपने अपनी योजना में {words_allowed} में से {words_used} अनुवादित शब्द उपयोग किए हैं।",
      "paidReachedLimit": "आपने वर्तमान योजना की अधिकतम अनुवादित शब्द सीमा तक पहुँच गए हैं।\nअपनी वेबसाइट सामग्री का अनुवाद जारी रखने के लिए अपनी योजना अपग्रेड करें।",
      "trialOfferedUsage": "आप वर्तमान में {words_allowed} शब्द वाली परीक्षण योजना में {words_used} शब्द उपयोग कर रहे हैं। (इसमें दिए गए {free_words} शब्द शामिल हैं)",
      "paidOfferedUsage": "आपने अपनी योजना में {words_allowed} में से {words_used} अनुवादित शब्द उपयोग किए हैं। (इसमें दिए गए {free_words} शब्द शामिल हैं)",
      "noPlanExtra": "कृपया ध्यान दें कि निष्क्रिय डोमेन और उनका डेटा नियमित रूप से स्वचालित रूप से हटाए जाते हैं।",
      "planRecommended": "आपके वर्तमान अनुवाद आयतन के आधार पर, अनुशंसित योजना है:",
      "planMaximumWords": "{{words}} शब्द",
      "notHaveTranslatedWords": "आपने अभी तक कोई अनुवाद नहीं किया है"
    },
    "translationSetup": {
      "kicker": "सबडोमेन सेटअप",
      "title": "अनुवाद सेटअप जाँचें",
      "description": "DNS, अनुवादित होस्ट, मूल साइट तक पहुँच और खाते की सीमाएँ देखें।",
      "starting": "जाँच हो रही है...",
      "button": "सेटअप जाँचें",
      "viewLatest": "नवीनतम परिणाम देखें",
      "viewCurrent": "वर्तमान जाँच देखें",
      "runAgain": "फिर से जाँचें",
      "viewDetails": "विवरण देखें",
      "hideDetails": "विवरण छिपाएँ",
      "error": "सेटअप जाँचा नहीं जा सका",
      "allPassed": "सभी जाँच सफल रहीं",
      "setupNeedsAttention": "सेटअप पर ध्यान देना आवश्यक है",
      "setupNeedsAttentionDescription": "एक या अधिक जाँच विफल हुईं। नीचे दिए गए आइटम देखें या Linguise सहायता से संपर्क करें।",
      "lastChecked": "अंतिम जाँच {{time}}",
      "domainOwnership": "डोमेन का स्वामित्व",
      "domainOwnershipDescription": "सत्यापन रिकॉर्ड मिला",
      "domainOwnershipFailure": "स्वामित्व के DNS रिकॉर्ड का सत्यापन नहीं हो सका।",
      "translatedHosts": "अनुवादित होस्ट",
      "translatedHostsDescription": "{{count}} भाषा होस्ट जाँचे गए",
      "translatedHostsFailure": "एक या अधिक भाषा CNAME रिकॉर्ड गलत हैं।",
      "subdomainPage": "सबडोमेन पृष्ठ",
      "subdomainPageDescription": "{{count}} अनुवादित पृष्ठ HTTPS स्वीकार करते हैं",
      "subdomainPageFailure": "एक या अधिक अनुवादित पृष्ठ खोलते समय TLS कनेक्शन विफल हुआ।",
      "originalSite": "मूल साइट",
      "originalSiteDescription": "मूल साइट के DNS, TLS और प्रतिक्रिया की जाँच",
      "originalSiteFailure": "मूल साइट की DNS, TLS या प्रतिक्रिया जाँच विफल हुई।",
      "documentationAdvice": {
        "dns": "DNS सेटअप देखें",
        "tls": "HTTPS सेटअप देखें",
        "origin": "मूल साइट का सेटअप देखें",
        "diagnostic": "समस्या निवारण के चरण देखें"
      },
      "evidence": {
        "originDns": "मूल DNS",
        "originTls": "मूल TLS",
        "originHttp": "मूल प्रतिक्रिया",
        "observedTargets": "देखे गए लक्ष्य",
        "recordCount": "रिकॉर्ड मिले",
        "addressCount": "पते मिले",
        "statusCode": "HTTP स्थिति",
        "redirect": "रीडायरेक्ट",
        "expiresAt": "प्रमाणपत्र की समय सीमा",
        "raw": "{{key}}",
        "noValue": "कोई मान नहीं"
      },
      "checkerError": "कुछ जाँच पूरी नहीं हो सकीं।",
      "coreLocation": "{{location}} से जाँचा गया",
      "status": {
        "queued": "कतार में",
        "running": "चल रहा है",
        "completed": "पूरा हुआ",
        "failed": "विफल",
        "passed": "सफल",
        "warning": "चेतावनी",
        "unknown": "अज्ञात",
        "skipped": "छोड़ा गया",
        "not_applicable": "लागू नहीं"
      }
    },
    "throttling": {
      "title": "अनुवाद सीमा",
      "description": "अस्थायी उपयोग सीमाएँ",
      "unavailable": "अस्थायी अनुवाद सीमाएँ उपलब्ध नहीं हैं",
      "window": "{{used}} / {{max}} शब्द",
      "resetsIn": "{{time}} में रीसेट होगा",
      "throttled": "अनुवाद अस्थायी रूप से रुका हुआ है",
      "throttledDescription": "अस्थायी उपयोग सीमा पूरी हो गई है। यह अवधि रीसेट होने पर अनुवाद फिर शुरू होगा।"
    }
  },
  "domain": {
    "wizard": {
      "stepLabel": "चरण {{step}} / {{total}}",
      "doneLabel": "हो गया, आप अनुवाद शुरू कर सकते हैं!",
      "finish": {
        "title": "",
        "description": "यह API कुंजी है जिसे आपकी वेबसाइट पर उपयोग करना है"
      },
      "instructions": "स्थापना निर्देश",
      "domainSetting": "डोमेन सेटिंग",
      "step": {
        "titleWordpress": "वर्डप्रेस",
        "titleJoomla": "जूमला",
        "titlePHP": "PHP स्क्रिप्ट",
        "wizardWordpressStep1": "1. इन्स्टॉल करें ",
        "wizardWordpressStep2": "\n 2. प्लगइन सेटिंग्स में अपनी API कुंजी कॉपी करें और भरें\n",
        "wizardWordpressStep3": "3. आप अनुवाद करने के लिए तैयार हैं\n\n",
        "wizardWordpressStep4": "अधिक विस्तृत निर्देशों के लिए, कृपया हमारे दस्तावेज़ देखें: ",
        "wizardJoomlaStep1": "1. Joomla पैकेज लिंक: ",
        "wizardJoomlaStep2": "\n2. एक्सटेंशन कॉन्फ़िगरेशन सेटिंग्स में अपनी API कुंजी कॉपी करें और भरें",
        "wizardJoomlaStep3": "3. मॉड्यूल कॉन्फ़िगरेशन में वे भाषाएँ चुनें जिन्हें आप दिखाना चाहते हैं, और अपना मॉड्यूल जहाँ चाहें वहाँ डालें।",
        "wizardJoomlaStep4": "\n4. अनुवाद करने के लिए तैयार हैं\n\n",
        "wizardPhpStep1": "1. हमारा PHP स्क्रिप्ट डाउनलोड करें और यहाँ ",
        "wizardPhpStep2": "\n2. हमारे दस्तावेज़ पृष्ठ पर यहाँ दी गई इंस्टॉलेशन निर्देशों का पालन करें ",
        "wizardPhpStep3": "\n3. अपने पृष्ठों में मॉड्यूल जोड़ें।",
        "wizardPhpStep4": "\n नीचे दिया गया कोड कॉपी करें और अपने HTML पृष्ठ के head में जोड़ें; यह ऑटोमैटिक रूप से स्विचर मॉड्यूल दिखाएगा\n",
        "dispatchStep1": "हमने आवश्यक डेटा Linguise प्लगइन को सफलतापूर्वक भेज दिया है, आप अब यह विंडो बंद कर सकते हैं।",
        "dispatchStep2": "यदि आप यह विंडो बंद करते समय टोकन गायब है, तो कृपया निम्नलिखित टोकन कॉपी करें:",
        "dispatchStep3": "आप हमारा फ्लैग स्विचर ऑटोमैटिकली सक्षम करने के लिए यह स्निपेट भी कॉपी कर सकते हैं",
        "wizardOtherStep1": "अपने डोमेन पर Linguise इंस्टॉल करने के लिए नीचे दिए निर्देशों का पालन करें।\n",
        "wizardOtherStep2": "निम्नलिखित कोड कॉपी करें और अपने HTML पृष्ठ के head में जोड़ें; यह ऑटोमैटिक रूप से स्विचर मॉड्यूल दिखाएगा।\n"
      },
      "trialAlreadyUsed": "ऐसा लगता है कि आप अपना निःशुल्क ट्रायल पहले ही उपयोग कर चुके हैं, इसलिए आपको अनुवाद कोटा प्राप्त करना होगा\nकृपया कोई योजना सब्सक्राइब करें या यदि आप अपना ट्रायल बढ़ाना चाहते हैं तो हमसे संपर्क करें।",
      "usefulLinks": "शुरुआत के लिए उपयोगी लिंक",
      "linkDocumentation": "दस्तावेज़",
      "linkExtensionDl": "एक्सटेंशन डाउनलोड",
      "linkSubscribe": "अभी कोई योजना सब्सक्राइब करें",
      "linkDashboard": "डैशबोर्ड पर जाएँ",
      "exclusion": {
        "title": "कंपनी और उत्पादों के नाम",
        "description": ""
      },
      "finishButton": "सेटअप समाप्त करें",
      "subdomains": "उपडोमेन",
      "subdomain_setup": "डोमेन सेटअप करें",
      "subdomain_auto_setup": "अपना DNS ऑटोमैटिकली कनेक्ट करें",
      "subdomain_manual_setup": "खुद DNS प्रविष्टियाँ जोड़ें",
      "subdomain_skip": "बाद में करें",
      "auto_subdomains_info": "आपकी साइट बिल्डर CMS को प्रति उपडोमेन भाषाएँ सेट करने के लिए DNS कॉन्फ़िगरेशन की आवश्यकता होती है (उदा. hi.domain.com)।",
      "auto_subdomains_info_2": "आप Entri का उपयोग करके इसे ऑटोमैटिकली कर सकते हैं। अपने DNS मैनेजर से कनेक्ट करना प्रारंभ करने के लिए बस \"Connect your DNS automatically\" बटन पर क्लिक करें और उन्हें Entri के साथ जोड़ें।",
      "auto_subdomains_info_manual": "या, आप \"Add DNS entries myself\" बटन पर क्लिक करके अपना डोमेन मैन्युअल रूप से कॉन्फ़िगर कर सकते हैं।",
      "breadcrumbs": {
        "step1": "चरण 1: डोमेन, सीएमएस और भाषाएँ",
        "step2": "चरण 2: भाषा डीएनएस",
        "step3": "चरण {{step}}: स्थापना निर्देश"
      }
    },
    "form": {
      "urls": {
        "dash": "डैश -",
        "underscore": "अंडरस्कोर _",
        "title": "URLs अनुवाद करें",
        "description": "क्या आप सभी पृष्ठों में अनुवाद करना चाहते हैं",
        "char_description": "URLs में अनधिकृत अक्षरों को प्रतिस्थापित करने के लिए उपयोग होने वाला वर्ण",
        "advertisement_title": "⚠ आपने बहुत सी भाषाएँ सेट की हैं।\n",
        "advertisement": "हम सामान्यतः वेबसाइटों का अनुवाद शुरू में कुछ ही भाषाओं से करने की सलाह देते हैं। आपको अंदाजा होगा कि आपकी वेबसाइट में कितने शब्द हैं। SEO के लिए भी यह बेहतर है, क्योंकि Google bots जल्दी से सभी पृष्ठों को क्रॉल करेंगे यदि आरंभ में कम पृष्ठ हों। एक सप्ताह बाद आप कुछ और भाषाएँ जोड़ सकते हैं, और इसी तरह।"
      },
      "url": {
        "title": "Url",
        "description": "अपना मुख्य डोमेन URL डालें जो http:// या https:// से शुरू हो",
        "placeholder": "डोमेन URL",
        "advertisement_http": {
          "title": "आप https प्रोटोकॉल का उपयोग नहीं कर रहे हैं",
          "description": "कृपया जाँच लें कि आपका डोमेन वास्तव में https प्रोटोकॉल का उपयोग नहीं कर रहा है, जो आजकल अनुशंसित है।"
        },
        "advertisement_www": {
          "title": "आपका उपडोमेन www नहीं है",
          "description": "अधिकतर समय डिफ़ॉल्ट उपडोमेन www होता है (जैसे https://www.mydomain.com)। हो सकता है यह आपका मामला न हो, लेकिन कृपया दुबारा जाँच लें कि आप जो डोमेन जोड़ना चाहते हैं वह सही है।"
        },
        "invalid_url": {
          "line1": "हम आपका डोमेन नहीं ढूंढ पाए। कृपया जाँच लें कि आपका डोमेन सार्वजनिक रूप से इंटरनेट पर सुलभ है और यह किसी अन्य स्थान पर रीडायरेक्ट नहीं हो रहा है।",
          "line2": "यदि आप निश्चित हैं कि आपका डोमेन सुलभ है, तो आप डोमेन सत्यापन छोड़ सकते हैं और \"Next step\" बटन को फिर से दबाएँ",
          "contact": "किसी भी स्थिति में आप हमसे संपर्क कर सकते हैं",
          "force": "डोमेन सत्यापन छोड़ें"
        },
        "invalid_subdomain_url": "यह यूआरएल मान्य नहीं है। सबडोमेन इस प्रकार होने चाहिए: https://www.domain.tld या https://domain.tld (बिना सबडायरेक्ट्री के)।"
      },
      "account": {
        "title": "खाता",
        "description": "इस डोमेन को असाइन करने के लिए कोई खाता चुनें",
        "placeholder": "खाता चुनें...",
        "feedback": "आपको एक खाता चुनना होगा"
      },
      "platform": {
        "title": "प्लेटफ़ॉर्म",
        "description": "कृपया अपनी वेबसाइट प्लेटफ़ॉर्म CMS नाम से चुनें।",
        "learn": "इसे चुनना कैसे सीखें",
        "placeholder": "CMS नाम से प्लेटफ़ॉर्म खोजें...",
        "info": {
          "title": "⚠ यह प्लेटफ़ॉर्म हाल ही में जोड़ा गया है।\n",
          "desc": "यह वेबसाइट बिल्डर प्लेटफ़ॉर्म Linguise द्वारा समर्थित है, हालाँकि इसे हाल ही में जोड़ा गया है। यदि आपको कोई समस्या आए, तो कृपया सीधे सपोर्ट ईमेल से हमसे संपर्क करें:"
        },
        "description_read_only": "वह प्लेटफ़ॉर्म जिस पर आपकी वेबसाइट चल रही है",
        "feedback": "आपको एक प्लेटफ़ॉर्म चुनना होगा"
      },
      "language": {
        "title": "भाषा",
        "description": "अपनी वेबसाइट की बेस भाषा चुनें",
        "placeholder": "भाषा चुनें...",
        "feedback": "आपको एक भाषा चुननी होगी",
        "description_read_only": "आपकी वेबसाइट की बेस भाषा"
      },
      "token": {
        "title": "API कुंजी",
        "description": "यह वह API कुंजी है जिसे आपको अपनी वेबसाइट पर कॉपी करना है",
        "copy": "क्लिपबोर्ड पर कॉपी करें",
        "reset": "API कुंजी रीसेट करें",
        "reset_confirm": "कृपया API कुंजी रीसेट की पुष्टि करें"
      },
      "languages": {
        "title": "भाषाओं का अनुवाद",
        "description": "वे भाषाएँ चुनें जिनमें आप अपनी वेबसाइट का अनुवाद करना चाहते हैं",
        "placeholder": "भाषाएँ चुनें...",
        "feedback": "आपको एक भाषा चुननी होगी"
      },
      "defaultRules": {
        "title": "डिफ़ॉल्ट नियम",
        "description": "हमने अनुवाद को बेहतर बनाने और अनचाहे कंटेंट (जैसे WordPress डैशबोर्ड) के अनुवाद से बचने के लिए कुछ अनिवार्य नियम बनाए हैं।\nआप बाद में चाहें तो इन नियमों को हटा या संपादित कर सकते हैं।"
      },
      "disallow_deletion": "आप सक्रिय सब्सक्रिप्शन वाला डोमेन नहीं हटा सकते",
      "delete_confirm": "कृपया डोमेन हटाने की पुष्टि करें",
      "delete": "डोमेन हटाएँ",
      "dynamic": {
        "title": "डायनामिक कंटेंट का अनुवाद",
        "description": "JavaScript और AJAX अनुरोधों द्वारा उत्पन्न डायनामिक कंटेंट का अनुवाद होगा (यह विकल्प आपके अनुवाद उपयोग को बढ़ाएगा)"
      },
      "partial_translations": {
        "title": "आंशिक अनुवाद की अनुमति दें",
        "description": "यदि आपका खाता अपने अनुवाद कोटा तक पहुँच गया है लेकिन पृष्ठ को अभी भी अनुवाद की आवश्यकता है, तो Linguise उस कंटेंट के साथ पृष्ठ को प्रदर्शित करना जारी रख सकता है जो पहले ही अनुवादित हो चुका है।\nहालाँकि, कुछ हिस्से अनअनुवादित रहेंगे जब तक आप अपना कोटा अपग्रेड नहीं करते।\n\nयद्यपि थोड़ा-सा अनअनुवादित कंटेंट सामान्यतः SEO को नुकसान नहीं पहुँचाता, बहुत अधिक अनअनुवादित कंटेंट उपयोगकर्ता अनुभाव को प्रतिकूल प्रभावित कर सकता है।\nइससे निपटने के लिए, आप एक सीमा तय कर सकते हैं कि पृष्ठ पर कितने प्रतिशत अनअनुवादित कंटेंट की अनुमति होगी। यदि अनअनुवादित कंटेंट यह सीमा पार कर जाता है, तो उपयोगकर्ताओं को स्वचालित रूप से पृष्ठ के मूल भाषा संस्करण पर रीडायरेक्ट कर दिया जाएगा।",
        "never": "कभी नहीं"
      },
      "translate_error_pages": {
        "title": "एरर पृष्ठों का अनुवाद",
        "description": "Linguise सभी एरर पृष्ठों का अनुवाद कर सकता है, यद्यपि यदि आपके एरर पृष्ठ में डायनामिक कंटेंट हो—जैसे IP एड्रेस या रिक्वेस्ट ID—तो आपको इन पृष्ठों का अनुवाद करने से बचना चाहिए।",
        "not_found_page": {
          "title": "404 पृष्ठ का अनुवाद"
        },
        "error_page": {
          "title": "अन्य एरर पृष्ठों का अनुवाद"
        }
      },
      "plugin_mode": {
        "modal": {
          "title": "मौजूदा डोमेन मिला",
          "description": "इस उपयोगकर्ता के लिए एक मौजूदा डोमेन मिला है, क्या आप इसे उपयोग करना चाहते हैं?"
        }
      },
      "search_tl": {
        "title": "अनुवाद खोजें",
        "description": "अपनी वेबसाइट प्लेटफ़ॉर्म के लिए खोज अनुवाद सक्षम करें (प्रायोगिक, यह विकल्प आपके अनुवाद उपयोग को बढ़ाएगा)"
      },
      "shopify_promo": {
        "info": "खुशखबरी! अब हमारे पास Shopify का नेटिव ऐप है जिसे आप Shopify ऐप स्टोर से इंस्टॉल कर सकते हैं।",
        "hyperlink": "यहां क्लिक करें और ऐप से लिंग्विस इंस्टॉल करें।",
        "next_btn": "ऐप इंस्टॉल करने के लिए Shopify स्टोर पर जाएं",
        "info_legacy": "खुशखबरी! अब हमारे पास Shopify का नेटिव ऐप है जिसे आप Shopify ऐप स्टोर से इंस्टॉल कर सकते हैं।",
        "description_legacy": "\"Shopify Legacy\" के बजाय \"Shopify\" प्लेटफॉर्म चुनें।"
      },
      "wix_promo": {
        "info": "खुशखबरी! अब हमारे पास Wix का नेटिव ऐप है जिसे आप Wix ऐप मार्केट से इंस्टॉल कर सकते हैं।",
        "hyperlink": "यहां क्लिक करें और ऐप से लिंग्विस इंस्टॉल करें।",
        "next_btn": "ऐप इंस्टॉल करने के लिए Wix ऐप मार्केट पर जाएं",
        "info_legacy": "खुशखबरी! अब हमारे पास Wix का नेटिव ऐप है जिसे आप Wix ऐप मार्केट से इंस्टॉल कर सकते हैं।",
        "description_legacy": "\"Wix Legacy\" के बजाय \"Wix\" प्लेटफॉर्म चुनें।"
      },
      "ai_disallow_deletion": "एआई कोटा अभी भी उपलब्ध होने पर आप इस डोमेन को हटा नहीं सकते।\n\nयदि आप इस डोमेन को हटाना चाहते हैं तो कृपया हमारी सहायता टीम से संपर्क करें",
      "language_removal": {
        "card": {
          "title": "हटाई गई भाषाओं के अनुवाद हटाएँ",
          "description": "इन भाषाओं को आपकी वेबसाइट से हटा दिया गया था, लेकिन इनके सहेजे गए अनुवाद अब भी आपके कोटे में गिने जाते हैं। शब्द वापस पाने के लिए इन्हें हटाएँ।",
          "button": "अनुवाद हटाएँ"
        },
        "hint": "इनमें इस्तेमाल हुए शब्द आपके कोटे में वापस जुड़ जाएंगे। आप हर वेबसाइट के लिए हर {{days}} दिन में एक बार ऐसा कर सकते हैं।",
        "modal": {
          "title": "अनुवाद हटाएँ?",
          "intro": "ये अनुवाद स्थायी रूप से हटाए जाएंगे:",
          "warning": "इसे वापस नहीं किया जा सकता। इस्तेमाल हुए शब्द आपके कोटे में लौटाए जाएंगे, जिसमें कुछ मिनट लग सकते हैं।",
          "limit": "आप हर वेबसाइट के लिए हर {{days}} दिन में एक बार ऐसा कर सकते हैं।",
          "confirm": "अनुवाद हटाएँ"
        },
        "scheduled": "अनुवाद हटाए जा रहे हैं और आपका कोटा जल्द अपडेट होगा।",
        "cooldown": "इस वेबसाइट के अनुवाद हाल ही में हटाए गए थे। आप इन्हें {{date}} को फिर हटा सकते हैं।",
        "latest_completed": {
          "title": "हाल ही में पूरा हुआ हटाने का काम",
          "description": "हटाई गई भाषाएँ और आपके कोटे में लौटे शब्द देखें।",
          "languages": "हटाई गई भाषाएँ",
          "words_returned": "आपके कोटे में लौटे शब्द: {{words}}",
          "completed_at": "{{date}} को पूरा हुआ"
        },
        "status": {
          "recent_title": "हाल ही में अनुवाद हटाना",
          "recent_description": "नवीनतम हटाने की प्रक्रिया देखें और जानें कि अगली बार कब उपलब्ध होगी।",
          "progress_title": "हटाने की प्रगति",
          "loading": "हटाने की प्रगति जाँची जा रही है...",
          "unavailable": "हटाने की प्रगति लोड नहीं हो सकी। पृष्ठ रीफ़्रेश करके फिर प्रयास करें।",
          "label": "स्थिति",
          "pending": "कतार में",
          "processing": "प्रगति पर",
          "completed": "पूरा हुआ",
          "failed": "विफल",
          "unknown": "स्थिति उपलब्ध नहीं",
          "percent": "{{percent}}% पूरा",
          "current_stage": "वर्तमान चरण: {{stage}}",
          "processed": "{{processed}} रिकॉर्ड संसाधित",
          "processed_total": "{{total}} में से {{processed}} रिकॉर्ड संसाधित",
          "requested_at": "{{date}} को अनुरोध किया गया",
          "started_at": "{{date}} को शुरू हुआ",
          "completed_at": "{{date}} को पूरा हुआ",
          "cooldown_period": "आप हर वेबसाइट के लिए हर {{days}} दिन में एक बार ऐसा कर सकते हैं।",
          "cooldown_blocked": "अभी दूसरी बार हटाने की प्रक्रिया शुरू नहीं की जा सकती।",
          "stage": {
            "queued": "शुरू होने की प्रतीक्षा में",
            "processing": "प्रगति पर",
            "refund_summary": "लौटाए गए शब्दों की गणना",
            "search_translations": "खोज अनुवाद हटाए जा रहे हैं",
            "url_translations": "URL अनुवाद हटाए जा रहे हैं",
            "translations": "अनुवाद हटाए जा रहे हैं",
            "completed": "पूरा हुआ",
            "failed": "विफल",
            "unknown": "प्रगति पर"
          }
        },
        "forbidden": "आपको अनुवाद हटाने की अनुमति नहीं है।"
      }
    },
    "main": {
      "edit": "डोमेन संपादित करें",
      "add": "डोमेन जोड़ें",
      "wizard": "स्वागत है! नया डोमेन बनाने का विज़ार्ड",
      "common": "डोमेन"
    },
    "notice": {
      "broken_card": "हम आपकी वर्तमान भुगतान विधि का उपयोग करके {{url}} के लिए आपकी योजना नवीनीकृत नहीं कर सके, कृपया अपना भुगतान कार्ड अपडेट करें",
      "quota_reached": "{{url}} के लिए आपका अनुवाद कोटा पूरा हो गया है, कृपया अपनी वेबसाइट अनुवाद को फिर से शुरू करने के लिए अपग्रेड करें",
      "ai_no_subscription": "{{url}} के लिए AI अनुवाद के लिए एक सक्रिय सब्सक्रिप्शन या सक्रिय ट्रायल आवश्यक है। इसके बिना यह बंद हो जाएगा, कृपया जारी रखने के लिए अपग्रेड करें",
      "important": "महत्वपूर्ण",
      "quota_reached_button": "अभी अपनी योजना अपग्रेड करें",
      "broken_card_button": "अपना भुगतान कार्ड अपडेट करें",
      "ai_no_subscription_button": "अभी अपनी योजना अपग्रेड करें",
      "quota_warning": "{{url}} के लिए आपका अनुवाद कोटा {{throttling_used_percent}}% तक पहुँच गया है, यह {{ttl}} में रीसेट हो जाएगा।",
      "locked": "डोमेन {{url}} वर्तमान में माइग्रेशन के लिए लॉक कर दिया गया है, आप अभी भी अपनी साइट तक पहुंच सकते हैं लेकिन संपादित करने या नए अनुवाद जोड़ने में असमर्थ हैं!"
    },
    "subdomains": {
      "config_ok": "सबडोमेन डीएनएस को ठीक से कॉन्फ़िगर किया गया है।",
      "config_invalid": "सबडोमेन डीएनएस को काम करने के लिए कुछ अतिरिक्त कॉन्फ़िगरेशन की आवश्यकता है।",
      "config_check": "सबडोमेन डीएनएस कॉन्फ़िगरेशन की जाँच की जा रही है, कृपया प्रतीक्षा करें...",
      "entri_timeout": "एंट्री ने रिपोर्ट किया है कि आपके सबडोमेन डीएनएस प्रचार प्रक्रिया का समय समाप्त हो गया है, आपको पुनः प्रयास करना होगा या आप इसे मैन्युअल रूप से कर सकते हैं।",
      "entri_process": "आपके डीएनएस को एंट्री के साथ जोड़ा गया है और इसे प्रचारित होने में आमतौर पर 10-30 मिनट लगते हैं (आपकी सभी भाषा सबडोमेन जैसे hi.domain.com लागू करना)। यदि 24 घंटों के बाद भी डीएनएस मान्यता समाप्त नहीं होती है, तो आप हमारी सहायता टीम से संपर्क कर सकते हैं: support@linguise.com",
      "entri_ok": "डीएनएस प्रचार प्रक्रिया चल रही है! प्रचार की प्रतीक्षा...",
      "infos": "ट्रांसलेशन को सक्रिय करने के लिए आपको इन DNS प्रविष्टियों को अपने DNS डोमेन रिकॉर्ड में जोड़ना होगा। यह हो जाने पर चेक बटन पर क्लिक करें। DNS रिकॉर्ड को अपडेट होने में कुछ समय लग सकता है, इसलिए आपको कुछ मिनट या घंटों बाद वापस आना पड़ सकता है।",
      "check": "DNS कॉन्फ़िगरेशन की जाँच करें"
    },
    "subscription": {
      "next_payment_amount": "आगामी शुल्क",
      "next_payment_date": "अगली भुगतान तिथि",
      "invoice": {
        "header": "चालान इतिहास",
        "date": "तिथि",
        "amount_due": "राशि",
        "status": "स्थिति",
        "actions": "क्रियाएँ",
        "description": "एक बार लेन-देन उपलब्ध होने पर, आप उन्हें यहाँ देख सकते हैं।",
        "status_text": {
          "draft": "ड्राफ्ट",
          "failed": "विफल",
          "open": "लंबित",
          "paid": "भुगतान किया गया",
          "retrying": "पुनः प्रयास",
          "uncollectible": "वसूल योग्य नहीं",
          "void": "शून्य"
        },
        "view": "देखें",
        "empty": "इस सदस्यता के लिए कोई हालिया चालान नहीं मिला",
        "retry_payment": "पुनः प्रयास करें"
      },
      "next_cancellation": "रद्दीकरण तिथि",
      "cancel": "सदस्यता रद्द करें",
      "change_plan": "योजना बदलें",
      "change": "बदलें",
      "suspend": "भुगतान निलंबित करें",
      "resume": "सदस्यता फिर से शुरू करें",
      "back": "वापस",
      "save": "सहेजें",
      "confirm_resume": "क्या आप वाकई इस सदस्यता को फिर से शुरू करना चाहते हैं?",
      "confirm_cancel": "क्या आप वाकई इस सदस्यता को रद्द करना चाहते हैं?",
      "confirm_header": "क्या आपको यकीन है?",
      "missing_status": "यह सदस्यता गायब है",
      "not_found": "इस डोमेन के लिए कोई सदस्यता नहीं मिली",
      "confirm_manual_retry": "क्या आप वाकइ इस भुगतान को पुनः प्रयास करना चाहते हैं?",
      "no_payment_method": "अज्ञात",
      "remove_billing": "हटाएँ",
      "shopify_maneged": "यह सदस्यता Shopify द्वारा प्रबंधित है। कृपया इसे अपने Shopify एडमिन पैनल से प्रबंधित करें।",
      "unknown_plan": "अज्ञात योजना"
    }
  },
  "domain_listing": {
    "add": "वेबसाइट जोड़ें",
    "select": "एक डोमेन चुनें"
  },
  "editable": {
    "number": "संख्या {{id}}"
  },
  "footer": {
    "about": "बारे में",
    "support": "सहायता"
  },
  "frontendEditor": {
    "main": "लाइव संपादक",
    "description": "लाइव संपादक आपको सीधे आपकी वेबसाइट में अनुवाद संपादित करने में मदद करता है।",
    "button": "लाइव संपादक खोलें",
    "language_selection": "अनुवाद भाषा चयन",
    "video_label": "लाइव संपादक का उपयोग करना सीखें"
  },
  "general": {
    "403": {
      "tab_title": "उफ़ - 403 त्रुटि",
      "title": "पहुँच अस्वीकृत",
      "message": "लगता है कि आपको अनुरोधित पृष्ठ तक पहुँच नहीं है।",
      "home": "होम पर लौटें"
    },
    "404": {
      "tab_title": "उफ़ - 404 त्रुटि",
      "title": "पृष्ठ नहीं मिला",
      "message": "लगता है आपने गलत मोड़ ले लिया हो। चिंता न करें... यह सबके साथ होता है। यहाँ एक छोटा सुझाव है जो आपकी मदद कर सकता है।",
      "home": "होम पर लौटें"
    },
    "500": {
      "tab_title": "500 त्रुटि",
      "title": "आंतरिक सर्वर त्रुटि",
      "message": "क्यों न पृष्ठ को रीफ़्रेश करने का प्रयास करें? या आप हमसे संपर्क कर सकते हैं",
      "home": "होम पर लौटें"
    },
    "fields": {
      "alert": "कुछ फ़ील्ड मान्य नहीं हैं, कृपया अमान्य फ़ील्ड को ठीक करें।",
      "invalid": "यह फ़ील्ड अमान्य है",
      "phone_re": "फ़ोन नंबर अमान्य है",
      "phone_invalid": "फ़ोन नंबर अमान्य है",
      "email": "ईमेल फ़ील्ड अमान्य है"
    },
    "table": {
      "no_data": "यहाँ अभी कोई डेटा नहीं है..."
    },
    "saving": "सहेजा जा रहा है ...",
    "save": "सहेजें",
    "save_and_quit": "सहेजें और छोड़ें",
    "invite": "आमंत्रित करें",
    "cancel": "रद्द करें",
    "yes": "हाँ",
    "no": "नहीं",
    "nextStep": "अगला चरण",
    "loading": "कृपया प्रतीक्षा करें जब तक अनुप्रयोग लोड हो रहा है",
    "goback": "वापस जाएँ",
    "manage": "प्रबंधन",
    "delete": "हटाएँ",
    "deleting": "हटाया जा रहा है ...",
    "confirm": "पुष्टि करें",
    "unknown": "अज्ञात",
    "hide": "छिपाना",
    "show": "दिखाओ",
    "on": "पर",
    "off": "बंद",
    "default": "डिफ़ॉल्ट"
  },
  "home": {
    "header": "होम",
    "manage": "सदस्यता प्रबंधन",
    "canceled": "रद्दीकरण के लिए निर्धारित",
    "activate_now": "अभी सक्रिय करें",
    "activate_plan_now": "अभी सदस्यता लें",
    "upgrade_plan_now": "अभी योजना अपग्रेड करें",
    "trial_message_part_1": "आप वर्तमान में परीक्षण योजना पर हैं, ",
    "trial_message_part_2": "आप कभी भी सदस्यता सक्रिय कर सकते हैं।",
    "add": "डोमेन जोड़ें",
    "table": {
      "title": "डोमेन",
      "description": "आपके डोमेन की सूची, अनुवाद प्रबंधित करने के लिए डोमेन पर क्लिक करें"
    },
    "domains": {
      "empty": "इस खाते में आपका कोई डोमेन नहीं है"
    },
    "accountsList": {
      "title": "खाते",
      "add": "नया खाता जोड़ें",
      "name": "खाता नाम"
    },
    "update_credit_card": "क्रेडिट कार्ड विवरण अपडेट करें",
    "cancelling_subs": "{{0}} पर रद्द किया जा रहा है",
    "resume_subscription": "सदस्यता फिर से शुरू करें",
    "shopify_managed": "Shopify द्वारा प्रबंधित",
    "trial_ends_at": "{{0}} पर समाप्त होता है",
    "free_trial": "मुफ्त परीक्षण",
    "no_subs": "कोई सक्रिय सदस्यता नहीं"
  },
  "invoices": {
    "title": "चालान",
    "list": {
      "title": "चालान सूची"
    },
    "table": {
      "customer": "ग्राहक",
      "domain": "डोमेन",
      "amountPaid": "भुगतान की गई राशि",
      "status": "स्थिति",
      "date": "तिथि",
      "invoice": "चालान",
      "pay": "चालान का भुगतान करें",
      "actions": "क्रियाएँ",
      "deleted_domain": "डोमेन हटाया गया",
      "plan_name": "प्लान",
      "action": "क्रिया"
    },
    "listPending": {
      "title": "लंबित चालान सूची"
    }
  },
  "language_settings": {
    "display": "भाषा सूची प्रदर्शन",
    "position": "स्थिति",
    "display_help_text": "फ्लैग और/या भाषा नाम प्रदर्शित करें. भाषा स्विचर की डिफ़ॉल्ट स्थिति सामग्री में कहीं भी हो सकती है या एक निश्चित स्थिति में जो तय रहती है या स्क्रॉल पर चलती है",
    "side_by_side": "बगल में",
    "dropdown": "ड्रॉपडाउन",
    "popup": "पॉपअप",
    "flag": "फ्लैग",
    "lang_name": "भाषा नाम",
    "lang_short_name": "संक्षिप्त नाम",
    "positions": {
      "in_place": "स्थान पर",
      "top_left": "ऊपर बाएँ",
      "top_left_no_scroll": "ऊपर बाएँ (नो-स्क्रॉल)",
      "top_right": "ऊपर दाएँ",
      "top_right_no_scroll": "ऊपर दाएँ (नो-स्क्रॉल)",
      "bottom_left": "नीचे बाएँ",
      "bottom_left_no_scroll": "नीचे बाएँ (नो-स्क्रॉल)",
      "bottom_right": "नीचे दाएँ",
      "bottom_right_no_scroll": "नीचे दाएँ (नो-स्क्रॉल)"
    },
    "lang_names_display": {
      "title": "भाषा नाम प्रदर्शन",
      "help_text": "भाषा स्विचर में भाषा नाम अंग्रेज़ी में या मूल भाषा में प्रदर्शित करें, जैसे French या Français",
      "english": "अंग्रेज़ी",
      "native_languages": "मूल भाषाएँ"
    },
    "flag_shape": {
      "title": "फ्लैग शैली",
      "help_text": "गोल svg या आयताकार svg फ्लैग आइकन का उपयोग करें",
      "round": "गोल",
      "rectangular": "आयताकार"
    },
    "english_flag_type": {
      "title": "अंग्रेज़ी फ्लैग प्रकार",
      "help_text": "अंग्रेज़ी के लिए ग्रेट ब्रिटेन या यूएसए फ्लैग का उपयोग करें",
      "usa": "अमेरिकी ध्वज",
      "great_britain": "ब्रिटेन का ध्वज"
    },
    "german_flag_type": {
      "title": "जर्मन ध्वज का प्रकार",
      "help_text": "German के लिए Austria या German फ्लैग का उपयोग करें",
      "german": "जर्मन ध्वज",
      "austria": "ऑस्ट्रियाई ध्वज"
    },
    "spain_flag_type": {
      "title": "स्पेनिश ध्वज का प्रकार",
      "help_text": "Spanish के लिए Mexico या Spanish फ्लैग का उपयोग करें",
      "spanish": "स्पेनिश ध्वज",
      "mexico": "मेक्सिको का ध्वज",
      "peruvian": "पेरू का ध्वज"
    },
    "portugal_flag_type": {
      "title": "पुर्तगाली ध्वज का प्रकार",
      "help_text": "Portuguese के लिए Portuguese या Brazilian फ्लैग का उपयोग करें",
      "portugal": "पुर्तगाली ध्वज",
      "brazil": "ब्राज़ीलियाई ध्वज"
    },
    "taiwanese_flag_type": {
      "title": "ताइवानी ध्वज का प्रकार",
      "help_text": "Taiwanese के लिए Taiwanese या Chinese फ्लैग का उपयोग करें",
      "taiwanese": "ताइवानी ध्वज",
      "chinese": "चीनी ध्वज"
    },
    "flag_border_radius": {
      "title": "फ्लैग बॉर्डर रेडियस (px)",
      "help_text": "यदि आप आयताकार फ्लैग आकार का उपयोग कर रहे हैं तो आप पिक्सेल में कस्टम बॉर्डर रेडियस लागू कर सकते हैं"
    },
    "flag_width": {
      "title": "फ्लैग आकार (px)",
      "help_text": "पिक्सेल में फ्लैग आकार चुनें। यह चित्र के वज़न को नहीं बदलता क्योंकि यह .svg प्रारूप है"
    },
    "lang_color": {
      "color_title": "भाषा नाम रंग",
      "color_help_text": "अपने भाषा नामों के लिए डिफ़ॉल्ट टेक्स्ट रंग चुनें",
      "hover_color_title": "भाषा नाम होवर रंग",
      "hover_color_help_text": "अपने भाषा नामों के लिए माउस होवर टेक्स्ट रंग चुनें",
      "color_popup_title": "पॉपअप भाषा रंग",
      "color_popup_help_text": "पॉपअप या ड्रॉपडाउन क्षेत्रों में भाषा शीर्षक का रंग",
      "hover_color_popup_title": "पॉपअप भाषा होवर रंग",
      "hover_color_popup_help_text": "पॉपअप या ड्रॉपडाउन क्षेत्रों में भाषा शीर्षक का माउस होवर टेक्स्ट रंग चुनें"
    },
    "flag_box_shadow": {
      "shadow_title": "फ्लैग बॉक्स शैडो",
      "shadow_help_text": "आपकी भाषा फ्लैग्स के लिए रंग और शैडो आकार",
      "hover_shadow_title": "होवर पर फ्लैग बॉक्स शैडो",
      "hover_shadow_help_text": "माउस होवर पर आपकी भाषा फ्लैग्स के लिए रंग और शैडो आकार",
      "shadow_h_offset": "छाया का क्षैतिज ऑफ़सेट (px)",
      "shadow_v_offset": "छाया का लंबवत ऑफ़सेट (px)",
      "shadow_blur": "छाया का धुंधलापन (px)",
      "shadow_spread": "छाया का फैलाव (px)",
      "shadow_color": "छाया का रंग"
    },
    "order": "भाषा क्रम",
    "language_order_help": "भाषा स्विचर में दिखाई देने वाली भाषा का क्रम। आप फिर से क्रमबद्ध करने के लिए भाषा को खींच और छोड़ सकते हैं।",
    "order_reset": "क्रम रीसेट करें",
    "language_order_dragdrop": "आप फिर से क्रमबद्ध करने के लिए भाषा को खींच और छोड़ सकते हैं।",
    "popup_lang_name": "पॉपअप भाषा नाम",
    "preview": "भाषा पूर्वावलोकन"
  },
  "link": {
    "form": {
      "original": {
        "title": "मूल स्रोत",
        "description": "नीचे अपना मूल लिंक URL डालें और इसे भाषा द्वारा अनुवादित करने के लिए बदलें",
        "srcset_description": "आप एक चित्र url संपादित कर रहे हैं। कृपया दस्तावेज़ीकरण को अवश्य पढ़ें, विशेष रूप से यदि आप srcset का उपयोग करते हैं, या नहीं जानते कि यह क्या है",
        "link": "लिंक",
        "match_link": "मिलान मोड",
        "match_exact": "सटीक",
        "match_wildcard": "वाइल्डकार्ड",
        "match_regex": "रेगुलर एक्सप्रेशन"
      },
      "alternative_languages": {
        "title": "प्रतिस्थापित करने के लिए लिंक",
        "description": "अपने पृष्ठों में सभी मीडिया लिंक और बाहरी लिंक भाषा के अनुसार प्रतिस्थापित करें…",
        "link": "प्रतिस्थापित करने के लिए लिंक"
      },
      "error": {
        "atLeastOne": "कृपया कम से कम एक अनुवाद जोड़ें।",
        "url": "URL अमान्य है",
        "extension": "लिंक में एक एक्सटेंशन होना चाहिए, लेकिन वह .html या .php नहीं हो सकता। और लिंक में कोई भाषा पथ नहीं होना चाहिए, उदाहरण के लिए \"/fr\"",
        "regex": "रेजेक्स अमान्य है",
        "wildcard": "वाइल्डकार्ड लिंक का प्रोटोकॉल अमान्य है"
      }
    },
    "main": {
      "parent": "लिंक",
      "edit": "लिंक संपादित करें"
    }
  },
  "links": {
    "title": "मीडिया और बाहरी लिंक प्रबंधन",
    "description": "अपनी वेबसाइट के मीडिया लिंक या बाहरी लिंक सूचीबद्ध और संपादित करें।",
    "add": "लिंक जोड़ें",
    "delete": "लिंक हटाएं",
    "table": {
      "original": "मूल",
      "language": "भाषा",
      "translation": "अनुवाद",
      "action": "क्रिया",
      "delete_confirm": "कृपया लिंक हटाने की पुष्टि करें"
    }
  },
  "members": {
    "header": "सदस्य",
    "invite": "नया सदस्य आमंत्रित करें",
    "modal": {
      "inviteHeader": "नया सदस्य आमंत्रित करें",
      "editHeader": "सदस्य संपादित करें",
      "detachHeader": "सदस्य को अलग करें",
      "detachBody": "क्या आप वाकई इस सदस्य को इस खाते से अलग करना चाहते हैं?",
      "selfDetachBody": "क्या आप वाकई इस खाता प्रबंधन से खुद को अलग करना चाहते हैं? इसके बाद आप इस खाते से संबंधित कोई भी डेटा तक पहुंच नहीं पाएंगे।"
    },
    "table": {
      "title": "सदस्य सूची",
      "description": "सदस्य भूमिकाएं और डोमेन पहुंच",
      "name": "नाम",
      "email": "ईमेल",
      "websites": "वेबसाइटें",
      "languages": "भाषाएं",
      "role": "भूमिका",
      "status": "स्थिति",
      "resendInvite": "फिर से भेजें",
      "inviteSent": "आमंत्रण भेजा गया",
      "actions": "क्रियाएं",
      "edit": "संपादित करें",
      "detach": "अलग करें",
      "empty": "आपके पास अभी कोई सदस्य नहीं है",
      "all_website": "सभी वेबसाइटें और भाषाएँ",
      "roles": {
        "admin": "प्रशासक",
        "manager": "प्रबंधक",
        "translator": "अनुवादक"
      },
      "statuses": {
        "pending": "लंबित",
        "accepted": "स्वीकार किया गया",
        "declined": "अस्वीकृत"
      }
    },
    "errors": {
      "role": "आपको एक भूमिका चुननी होगी",
      "domains": "चयनित भूमिका के लिए आपको कम से कम 1 वेबसाइट चुननी होगी",
      "languages": "चयनित वेबसाइटों के लिए आपको कम से कम 1 भाषा चुननी होगी"
    },
    "inviteSent": "आपका आमंत्रण सफलतापूर्वक भेज दिया गया है"
  },
  "pagination": {
    "showing": "{{total}} परिणामों में से {{limit}} दिखा रहे हैं",
    "showing_only_count": "{{limit}} परिणाम दिखा रहे हैं"
  },
  "payments_method": {
    "header": "भुगतान विधियां",
    "table": {
      "title": "भुगतान विधियों की सूची",
      "description": "आपके खाते से जुड़ी भुगतान विधियां",
      "default": "डिफ़ॉल्ट",
      "action_edit_remove": "संपादित करें या हटाएं",
      "action_remove": "हटाएं",
      "action_default": "डिफ़ॉल्ट के रूप में सेट करें",
      "action_fallback": "फॉलबैक के रूप में सेट करें",
      "expires": "समाप्ति",
      "add_new_card": "भुगतान विधि जोड़ें",
      "action_fallback_remove": "फॉलबैक से हटाएं",
      "fallback": "फॉलबैक",
      "action_edit": "संपादित करें",
      "action_delete": "हटाएं",
      "action_default_remove": "डिफ़ॉल्ट हटाएं",
      "domain_count@@one": "{{count}} डोमेन द्वारा उपयोग में",
      "domain_count@@other": "{{count}} डोमेन द्वारा उपयोग किया जाता है"
    },
    "paypal_bind": {
      "button": "PayPal खाता जोड़ें",
      "button_load": "जोड़ा जा रहा है...",
      "disconnected": "कनेक्ट नहीं है",
      "success": "आपका PayPal खाता अब कनेक्ट हो गया है, अगले बिल से $5 काटे जाएंगे!",
      "success_no_promo": "आपका PayPal खाता अब कनेक्ट हो गया है",
      "error": "कोई त्रुटि हुई है",
      "success_header": "सफलता"
    },
    "card_add": {
      "header": "नया कार्ड जोड़ें",
      "success": "Linguise से नया कार्ड कनेक्ट किया गया!",
      "terms": "अपना कार्ड विवरण देकर, आप Linguise को अपनी सेवा की शर्तों के अनुसार भविष्य के भुगतानों के लिए अपने कार्ड से चार्ज करने की अनुमति देते हैं।"
    },
    "card_detail": {
      "header": "कार्ड जानकारी",
      "delete": {
        "error": "आप इस भुगतान विधि को नहीं हटा सकते क्योंकि इस पर सक्रिय सदस्यताएं हैं!"
      }
    },
    "subscriptions": {
      "table": {
        "description": "इस भुगतान विधि पर सदस्यताएं",
        "header_domain": "डोमेन",
        "header_plan": "योजना",
        "header_status": "स्थिति",
        "header_actions": "क्रियाएं",
        "cancelling": "रद्द की जा रही है: {{0}}",
        "next_payment": "अगला भुगतान: {{0}}",
        "action_renew": "नवीनीकृत करें",
        "no_subs_header": "दिखाने के लिए कोई सदस्यता नहीं",
        "no_subs_desc": "जब इस कार्ड पर कोई सदस्यता बनती है, तो सभी जानकारी यहां प्रदर्शित होगी",
        "action_manage": "प्रबंधित करें"
      },
      "status": {
        "active": "सक्रिय",
        "canceled": "रद्द",
        "incomplete": "अनुपयुक्त",
        "incomplete_expired": "अनुपयुक्त (समाप्त)",
        "missing": "त्रुटि",
        "past_due": "बकाया",
        "trialing": "परीक्षण",
        "unpaid": "अनुपयुक्त"
      }
    },
    "delete_confirm_body": "क्या आप वाकई इस भुगतान विधि को हटाना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती!",
    "delete_confirm_header": "भुगतान विधि हटाएं?",
    "card_edit": {
      "header": "कार्ड संपादित करें",
      "billing_header": "बिलिंग जानकारी",
      "address_error": "पता आवश्यक है!",
      "card_number": "कार्ड नंबर",
      "card_expiry": "समाप्ति तिथि",
      "expiry_error_month": "अमान्य महीना दिया गया",
      "expiry_error_year": "अमान्य वर्ष दिया गया",
      "expiry_error_expired": "आपके कार की समाप्ति वर्ष पहले ही समाप्त हो चुका है।",
      "card_header": "कार्ड जानकारी",
      "expiry_error_empty": "यह फ़ील्ड आवश्यक है!"
    }
  },
  "plans": {
    "per": "प्रति",
    "wordsTranslated": "शब्द अनुवादित",
    "current": "वर्तमान",
    "archived": "संग्रहीत",
    "day": "दिन",
    "week": "सप्ताह",
    "month": "महीना",
    "year": "साल",
    "activate": "सक्रिय करें",
    "cancel": "रद्द करें",
    "change": "बदलें",
    "upgrade": "अपग्रेड करें",
    "downgrade": "डाउनग्रेड करें",
    "resume": "फिर से शुरू करें",
    "notEnoughWords": "पर्याप्त शब्द नहीं",
    "yearIntervalOnly": "वार्षिक योजना से माइग्रेट नहीं किया जा सकता",
    "subsCanceled": "एक और सब्सक्रिप्शन रद्दीकरण प्रगति पर है",
    "wordsUnlimited": "अनलिमिटेड शब्द",
    "tabs": {
      "day": "दैनिक कीमतें",
      "week": "साप्ताहिक कीमतें",
      "month": "मासिक कीमतें",
      "year": "वार्षिक कीमतें",
      "sub_texts": {
        "day": "एक निश्चित कीमत, हर रोज़",
        "week": "एक निश्चित कीमत, हर हफ्ते",
        "month": "एक निश्चित कीमत, हर महीने",
        "year": "एक महीना फ्री, साल में एक बार बिल"
      }
    },
    "details": {
      "new_languages": "कभी भी नई भाषाएँ जोड़ें",
      "one_month_trial": "हर नई वेबसाइट के लिए एक माह की मुफ्त ट्रायल",
      "multi_content_indexed": "100% बहुभाषी सामग्री इंडेक्स्ड",
      "translate_new_content": "नई सामग्री का तुरंत अनुवाद करें",
      "free_installation": "निःशुल्क इंस्टॉलेशन और सेटअप",
      "compared_monthly_plan": "मासिक योजनाओं की तुलना में एक महीना मुफ्त",
      "risk_free_recurring": "जोखिम-रहित आवर्ती भुगतान विफलता",
      "unlimited_languages": "अनलिमिटेड भाषाएँ और पेज व्यूज़",
      "high_server_resources": "उच्च सर्वर संसाधन",
      "billed": {
        "day": "प्रतिदिन बिलिंग",
        "week": "प्रति सप्ताह बिलिंग",
        "month": "प्रति माह बिलिंग",
        "year": "प्रति वर्ष बिलिंग"
      },
      "request_max_size": "{{0}} अधिकतम अनुरोध आकार"
    },
    "frequent_question": {
      "title": "अक्सर पूछे जाने वाले प्रश्न",
      "questions": {
        "trial": {
          "question": "क्या मैं नई वेबसाइट डोमेन पर ट्रायल उपयोग कर सकता हूँ?",
          "answer": "हाँ, हर नई वेबसाइट डोमेन के लिए हम 30 दिन की मुफ्त ट्रायल देते हैं, जिसे आप अपने खाते में जोड़ते हैं। इससे आप अपनी नई वेबसाइट पर ट्रांसलेशन सेवा को पूरी तरह से परख सकते हैं।"
        },
        "seo": {
          "question": "SEO सुधारने में कितना समय लगता है?",
          "answer": "सामग्री और बहुभाषी सामग्री को पूरी तरह इंडेक्स और रैंक होने में समय लगता है। आपकी वेबसाइट के ट्रैफिक और आकार के आधार पर यह 3 से 6 सप्ताह के बीच होता है।"
        },
        "quota": {
          "question": "क्या मानव अनुवाद कोटा में गिने जाते हैं?",
          "answer": "नहीं, शब्दों की गिनती केवल स्वचालित मशीन अनुवाद के लिए है। कोई सीमा के बिना अनुवादक स्वचालित अनुवादों को मैन्युअल रूप से संपादित कर सकता है।"
        }
      }
    },
    "best_offer": "सबसे अच्छा ऑफ़र",
    "period": {
      "days@@one": "दिन",
      "days@@other": "{{count}} दिन",
      "hours@@one": "घंटा",
      "hours@@other": "{{count}} घंटे",
      "minutes@@one": "मिनट",
      "minutes@@other": "{{count}} मिनट",
      "seconds@@one": "दूसरा",
      "seconds@@other": "{{count}} सेकंड"
    },
    "words": {
      "billion": "{{value}}B",
      "million": "{{value}}M",
      "thousand": "{{value}}K"
    },
    "throttling_info": "{{words}} शब्द प्रति {{period}}"
  },
  "profile": {
    "welcome": "स्वागत है!",
    "account": "मेरा खाता",
    "subscriptions": "सदस्यताएँ",
    "logout": "लॉगआउट"
  },
  "register": {
    "errors": {
      "password": "न्यूनतम 8 अक्षर, कोई भी कैरेक्टर"
    }
  },
  "route": {
    "dashboard": "डैशबोर्ड",
    "rules": "नियम",
    "translations": "अनुवाद",
    "search_translations": "खोजी क्वेरीज़",
    "urls_translations": "यूआरएल अनुवाद",
    "links": "मीडिया और बाहरी लिंक्स",
    "online_editor": "लाइव एडिटर",
    "settings": "सेटिंग्स",
    "domain": {
      "finish": "सेटिंग्स",
      "preconfig": "सेटिंग्स"
    },
    "home": "होम",
    "domain_list": "डोमेन सूची",
    "members": "सदस्य",
    "invoices": "चालान",
    "billing": "बिलिंग विवरण",
    "language_display": "भाषा के झंडे प्रदर्शन",
    "payment_methods": "भुगतान विधियाँ",
    "ai_translation": "एआई अनुवाद",
    "ai_translation_settings": "सेटिंग्स",
    "ai_translation_pricing": "कीमतें"
  },
  "rule": {
    "form": {
      "text_ignore": {
        "placeholder": "इग्नोर करने वाला टेक्स्ट",
        "add": "नया जोड़ें",
        "title": "इग्नोर करने की टेक्स्ट",
        "description": "एक या अधिक टेक्स्ट जोड़ें जिन्हें इग्नोर करना है",
        "ignore_case": "केस इग्नोर करें"
      },
      "html_content": {
        "title": "HTML सामग्री पर लागू करें",
        "description": "पूरे कॉन्टेंट पर नियम लागू करें या किसी विशिष्ट CSS सेलेक्टर का चयन करें",
        "all_page": "पूरा पृष्ठ",
        "css_selector": "CSS सेलेक्टर",
        "label": "CSS सेलेक्टर",
        "placeholder": "लागू होने के लिए सेलेक्टर",
        "add": "नया जोड़ें"
      },
      "apply_to_urls": {
        "title": "URL पर लागू करें",
        "description": "उन विशिष्ट URL का चयन करें जहाँ आप नियम लागू करना चाहते हैं",
        "all_urls": "सभी URL",
        "selected_urls": "चयनित URL",
        "label": "लागू करने के लिए Url",
        "placeholder": "लागू करने के लिए Url",
        "original_url": "मूल URLs",
        "translated_url": "अनुवादित URL",
        "wildcard": "वाइल्डकार्ड",
        "regex": "रेगुलर एक्सप्रेशन",
        "add": "नया जोड़ें",
        "expression": "एक्सप्रेशन प्रकार"
      },
      "apply_urls": {
        "title_exclude": "URL में बाहर रखें",
        "title_replace": "URL में बदलें",
        "title_description": "URL के अनुवाद पर भी यह नियम लागू करें"
      },
      "apply_languages": {
        "title": "भाषाओं पर लागू करें",
        "description": "उन विशिष्ट भाषाओं का चयन करें जहाँ आप नियम लागू करना चाहते हैं",
        "all_languages": "सभी भाषाएँ",
        "selected_languages": "चयनित भाषाएँ",
        "placeholder": "भाषाएँ चुनें...",
        "feedback": "आपको एक भाषा चुनना होगा"
      },
      "name": {
        "title": "शीर्षक",
        "description": "सुविधा के लिए अपने नियम को एक शीर्षक दें",
        "placeholder": "नियम का नाम"
      },
      "type": {
        "title": "प्रकार",
        "description": "आप जो नियम जोड़ना चाहते हैं उसका प्रकार चुनें",
        "text_ignore": "टेक्स्ट इग्नोर",
        "text_replace": "टेक्स्ट बदलें",
        "content_exclusion": "कंटेंट बहिष्करण",
        "url_exclusion": "URL द्वारा बहिष्करण",
        "ignore_inline": "इनलाइन इग्नोर करें",
        "full_description": {
          "text_ignore": "कुछ टेक्स्ट को अनुवादित होने से बचाने के लिए नियम जोड़ें। यह आपका उत्पाद नाम, ब्रांड नाम या अन्य तकनीकी तत्व हो सकते हैं जिन्हें आप अनुवादित नहीं करना चाहते।",
          "text_replace": "टेक्स्ट बदलें से आप कुछ टेक्स्ट को अपनी इच्छित अनुवाद से बदल सकते हैं, यह तब आवश्यक हो सकता है जब अनुवाद संदर्भ को अनदेखा करता है।",
          "content_exclusion": "कंटेंट बहिष्करण आपको पेज के कुछ हिस्सों का अनुवाद रोकने में मदद करेगा।\n यदि आप किसी पेज को पूरी तरह अनुवाद से बाहर रखना चाहते हैं (इस पेज के लिए कोई बहुभाषी URL नहीं और कोई अनुवादित सामग्री) तो कृपया \"URL द्वारा बहिष्करण\" प्रकार का उपयोग करें",
          "url_exclusion": "पेज अनुवाद बहिष्करण उन पेजों को सेट करने में मदद करेगा जिन्हें आप अनुवादित नहीं करना चाहते।",
          "ignore_inline": "कुछ कंटेंट को इनलाइन अनुवादित होने से बचाएँ, इसके बजाय प्रत्येक टैग को अलग से अनुवादित करें।"
        }
      },
      "text_replace": {
        "title": "बदलने के लिए टेक्स्ट",
        "description": "किसी टेक्स्ट को अपने विशिष्ट अनुवाद से बदलें। किसी भी टेक्स्ट को अपने पेजों में भाषा द्वारा बदलें…",
        "text_to_replace": "बदलने के लिए टेक्स्ट",
        "ignore_case": "केस इग्नोर करें",
        "text_type": "अनुवाद में बदलाव",
        "text_type_original": "मूल",
        "text_type_translation": "अनुवाद",
        "keep_case": "केस बनाए रखने का प्रयास करें",
        "add": "नया जोड़ें"
      },
      "content_exclusion": {
        "title": "कंटेंट बहिष्करण",
        "description": "एक या अधिक CSS सेलेक्टर चुनें जिनका अनुवाद नहीं होगा",
        "label": "CSS सेलेक्टर",
        "placeholder": "लागू करने के लिए सेलेक्टर",
        "add": "नया जोड़ें"
      },
      "multilingual_url": {
        "title": "बहुभाषी URL का उपयोग करें",
        "description": "यदि हाँ सेट किया गया है, तो URL का अनुवाद नहीं होगा लेकिन पेज बहुभाषी रहेगा अनुवादित सामग्री के साथ",
        "live_example_title": "लाइव उदाहरण",
        "live_example_description": "स्रोत URL: https://yourwebsite.com/page-not-translated",
        "live_example_multilingual": "जनरेट किया गया URL: https://yourwebsite.com/fr/page-not-translated",
        "live_example_no_multilingual": "जनरेट किया गया URL: https://yourwebsite.com/page-not-translated"
      },
      "rule_application": {
        "description": "नियम को स्थिर कंटेंट या डायनैमिक कंटेंट या दोनों पर लागू करें",
        "title": "कंटेंट पर लागू करें",
        "all": "सभी कंटेंट",
        "static": "स्थिर कंटेंट",
        "dynamic": "डायनैमिक कंटेंट"
      },
      "force_apply_urls": {
        "title_description": "URL के सभी अनुवाद पर यह नियम बलपूर्वक लागू करें, मौजूदा अनुवादों सहित!",
        "title_replace": "URL में बलपूर्वक बदलें",
        "title_exclude": "URL में बलपूर्वक बाहर रखें",
        "warning": "चेतावनी",
        "warning_part1": "इसे \"हाँ\" पर सेट करने से आपकी वेबसाइट URL अनुवाद टूट सकते हैं।",
        "warning_part2": "इससे अस्थायी या स्थायी रूप से 404 पेज जनरेट हो सकते हैं, कृपया केवल तब आगे बढ़ें जब आप परिणामों को समझते हों।",
        "warning_replacement_original": "अतिरिक्त चेतावनी: आप मूल कंटेंट को बदलने का प्रयास कर रहे हैं जो URL को प्रभावित कर सकता है, अनुवाद विफल हो सकता है क्योंकि Linguise मूल URL को सही ढंग से खोजने में असमर्थ है"
      }
    },
    "main": {
      "parent": "नियम",
      "edit": "नियम संपादित करें",
      "add": "नया नियम"
    }
  },
  "rules": {
    "text_ignore": {
      "preview_single_with_url": "\"{{text_ignore}}\" को कंटेंट और URL दोनों में इग्नोर किया जाएगा",
      "preview_single": "\"{{text_ignore}}\" को कंटेंट में इग्नोर किया जाएगा",
      "preview_more_with_url": "\"{{text_ignore}}\" और {{count}} और कंटेंट में इग्नोर किए जाएँगे",
      "preview_more": "\"{{text_ignore}}\" और {{count}} और कंटेंट में इग्नोर किए जाएँगे",
      "other_parameters": "इस नियम के लिए अन्य पैरामीटर सेट हैं, अधिक जानकारी के लिए संपादित बटन पर क्लिक करें"
    },
    "text_replace": {
      "preview_single_with_url": "\"{{original}}\" को \"{{replacement}}\" से कंटेंट और URLs दोनों में बदला जाएगा",
      "preview_single": "\"{{original}}\" को \"{{replacement}}\" से कंटेंट में बदला जाएगा",
      "preview_more_with_url": "\"{{original}}\" को \"{{replacement}}\" से कंटेंट और URLs दोनों में बदला जाएगा, और {{nb}} और",
      "preview_more": "\"{{original}}\" को \"{{replacement}}\" से कंटेंट में बदला जाएगा, और {{nb}} और",
      "other_parameters": "इस नियम के लिए अन्य पैरामीटर सेट हैं, अधिक जानकारी के लिए संपादित बटन पर क्लिक करें"
    },
    "content_exclusion": {
      "selectors": "{{nb}} CSS सेलेक्टर अनुवाद से बाहर रखे गए",
      "other_parameters": "इस नियम के लिए अन्य पैरामीटर सेट हैं, अधिक जानकारी के लिए संपादित बटन पर क्लिक करें"
    },
    "url_exclusion": {
      "some_multilingual": "{{nb}} URL अनुवाद से बाहर हैं, लेकिन बहुभाषी उपसर्ग बना रहता है",
      "some": "{{nb}} URL पूरी तरह अनुवाद से बाहर हैं",
      "all_multilingual": "सभी URL अनुवाद से बाहर हैं, लेकिन बहुभाषी उपसर्ग बना रहता है",
      "all": "सभी URL पूरी तरह अनुवाद से बाहर हैं",
      "other_parameters": "इस नियम के लिए अन्य पैरामीटर सेट हैं, अधिक जानकारी के लिए संपादित बटन पर क्लिक करें"
    },
    "ignore_inline": {
      "elements": "सभी इनलाइन कंटेंट को पेज में ब्लॉक कंटेंट के रूप में अनुवादित किया जाएगा",
      "all_elements": "कुछ इनलाइन कंटेंट को पेज में ब्लॉक कंटेंट के रूप में अनुवादित किया जाएगा",
      "other_parameters": "इस नियम के लिए अन्य पैरामीटर निर्धारित किए गए हैं, अधिक जानकारी प्राप्त करने के लिए एडिट बटन पर क्लिक करें।"
    },
    "title": "नियम प्रबंधन",
    "description": "अपनी वेबसाइट में अनुवाद सामग्री बहिष्करण और प्रतिस्थापन प्रबंधित करें",
    "add": "नया नियम जोड़ें",
    "table": {
      "title": "शीर्षक",
      "no_data": "यहाँ अभी तक कोई नियम नहीं हैं",
      "type": "प्रकार",
      "preview": "नियम पूर्वावलोकन",
      "action": "कार्रवाई",
      "delete_confirm": "कृपया नियम हटाने की पुष्टि करें",
      "types": {
        "text_ignore": "टेक्स्ट उपेक्षित करें",
        "text_replace": "टेक्स्ट प्रतिस्थापित करें",
        "content_exclusion": "सामग्री बहिष्करण",
        "url_exclusion": "URL बहिष्करण",
        "ignore_inline": "इनलाइन उपेक्षित करें",
        "unknown": "अज्ञात नियम"
      }
    },
    "apply_on_content": {
      "static": "यह नियम केवल स्थिर सामग्री पर लागू होगा।",
      "dynamic": "यह नियम केवल गतिशील सामग्री पर लागू होगा।"
    }
  },
  "search_translations": {
    "title": "खोज क्वेरी प्रबंधन",
    "description": "आपकी वेबसाइट की सभी अनुवादित खोज फ़ॉर्म टेक्स्ट सूचीबद्ध करें (अनुवादित भाषा से आपके डोमेन की आधारभूत भाषा तक)",
    "filter_languages": "भाषाओं से फ़िल्टर करें...",
    "filter_original": "मूल भाषा में टेक्स्ट फ़िल्टर करें",
    "filter_translation": "अनुवादित टेक्स्ट से फ़िल्टर करें",
    "table": {
      "original": "मूल",
      "language": "भाषा",
      "translation": "अनुवाद"
    }
  },
  "subscription": {
    "failure": {
      "tab_title": "सदस्यता असफल रही!",
      "title": "सदस्यता असफल रही!",
      "subtitle": "आपकी सदस्यता प्रक्रिया करते समय एक त्रुटि उत्पन्न हुई।",
      "home": "होम पर वापस जाएं",
      "generic": "Linguise की ओर से एक अज्ञात त्रुटि हुई है, कृपया व्यवस्थापक से संपर्क करें!"
    },
    "success": {
      "home": "डोमेन अनुवाद प्रबंधित करें",
      "message": "हम आपको सर्वोत्तम संभव अनुवाद अनुभव देने के लिए प्रतिबद्ध हैं। हमारा विशेषज्ञ टीम किसी भी प्रश्न या सहायता के लिए उपलब्ध है। आरंभ करने के लिए, बस नीचे बटन पर क्लिक करें।",
      "subtitle": "Linguise अनुवाद सेवा चुनने के लिए धन्यवाद",
      "title": "सदस्यता सक्रिय हो गई!",
      "tab_title": "सदस्यता के लिए धन्यवाद!"
    }
  },
  "subscriptions": {
    "success": {
      "tab_title": "सदस्यता सक्रिय हो गई!",
      "title": "सदस्यता सक्रिय हो गई!",
      "subtitle": "Linguise अनुवाद सेवा चुनने के लिए धन्यवाद",
      "message": "'हम आपको सर्वोत्तम संभव अनुवाद अनुभव देने के लिए प्रतिबद्ध हैं। हमारा विशेषज्ञ टीम किसी भी प्रश्न या सहायता के लिए उपलब्ध है। आरंभ करने के लिए, बस नीचे बटन पर क्लिक करें।",
      "home": "डोमेन अनुवाद प्रबंधित करें"
    },
    "edit": {
      "title": "सदस्यता प्रबंधित करें"
    },
    "list": {
      "title": "सदस्यताएं सूची",
      "description": "आपके डोमेन सदस्यताओं की सूची"
    },
    "table": {
      "domain": "डोमेन",
      "plan": "योजना",
      "status": "स्थिति",
      "card": "कार्ड",
      "usage": "उपयोग",
      "actions": "क्रियाएं",
      "payment_method": "भुगतान विधि"
    },
    "usage": {
      "paid": "{{words_used}} / {{words_allowed}} शब्द",
      "paidOffered": "{{words_used}} / {{words_allowed}} शब्द\n({{free_words}} मुफ्त शब्द शामिल)"
    },
    "popup": {
      "dueToday": "आज कुल बकाया",
      "nextPeriod": "{{date}} से शुरू हो रहा है"
    }
  },
  "topbar": {
    "accounts": {
      "choose": "एक खाता चुनें"
    }
  },
  "translation": {
    "main": {
      "parent": "अनुवाद",
      "edit": "अनुवाद संपादित करें"
    },
    "form": {
      "original": {
        "title": "{{language}} में मूल"
      },
      "is_inline": "यह अनुवाद इनलाइन सामग्री से बनाया गया है।",
      "inline_editor": {
        "count_warning": "इनलाइन क्षेत्रों की संख्या मूल संख्या से मेल नहीं खाती ({{current}} में से {{expected}})।",
        "restore_original": "मूल पाठ बहाल करें",
        "insert_placeholder": "प्लेसहोल्डर डालें",
        "drag": "क्षेत्र का क्रम बदलने के लिए खींचें",
        "area": "इनलाइन क्षेत्र {{index}}",
        "restore": "छूटे हुए इनलाइन क्षेत्र बहाल करें"
      },
      "translation": {
        "title": "{{language}} में अनुवाद",
        "description": "अनुवाद जिसे आप ओवरराइड करना चाहते हैं"
      }
    },
    "copy": {
      "title": "मैन्युअल अनुवाद में कॉपी करें",
      "label": "मैन्युअल में कॉपी करें"
    },
    "level": {
      "base": {
        "title": "बेस अनुवाद",
        "subtitle": "स्वचालित · Linguise Cloud अनुवाद",
        "empty": "इस टेक्स्ट के लिए कोई बेस अनुवाद नहीं है।",
        "overridden": "आपकी पसंद सहेजी गई है, लेकिन इसके बजाय सबसे नया एआई से बेहतर बनाया गया अनुवाद दिखाया जाता है क्योंकि एआई अनुवाद सेटिंग्स में “मैन्युअल और चयनित अनुवादों को ओवरराइड करें” हाँ है। अपनी पसंद का उपयोग करने के लिए इस सेटिंग को बंद करें।"
      },
      "not_generated": "तैयार नहीं हुआ",
      "none": "अभी कुछ नहीं",
      "ai": {
        "title": "एआई से बेहतर बनाया गया अनुवाद",
        "subtitle": "स्वचालित · Linguise AI",
        "empty_title": "इस टेक्स्ट के लिए अभी तैयार नहीं हुआ",
        "empty_description": "Linguise AI आपके पेज और वेबसाइट के संदर्भ का उपयोग करके अधिक स्वाभाविक अनुवाद देता है। यहाँ इसे पाने के लिए:",
        "empty_step_1": "एआई अनुवाद › सेटिंग्स पर जाएँ और एआई अनुवाद सक्षम करें को “केवल नियम”, “केवल लाइव एडिटर” या “नियम और लाइव एडिटर” पर सेट करें।",
        "empty_step_2": "इसे इस पेज से मेल खाने वाले नियम के साथ लागू करें, या लाइव एडिटर से पेज-दर-पेज सक्षम करें।",
        "empty_step_3": "तैयार होने पर एआई से बेहतर बनाया गया अनुवाद यहाँ दिखाई देगा। इसमें आपके एआई क्रेडिट खर्च होते हैं।",
        "open_settings": "एआई अनुवाद सेटिंग्स खोलें",
        "open_editor": "लाइव एडिटर खोलें",
        "overrides_selection": "आपकी पसंद सहेजी गई है, लेकिन इसके बजाय यह एआई से बेहतर बनाया गया अनुवाद दिखाया जाता है क्योंकि एआई अनुवाद सेटिंग्स में “मैन्युअल और चयनित अनुवादों को ओवरराइड करें” हाँ है। अपनी पसंद का उपयोग करने के लिए इस सेटिंग को बंद करें।",
        "overrides_version": "आपका चुना हुआ संस्करण सहेजा गया है, लेकिन इसके बजाय सबसे नया एआई-संवर्धित संस्करण दिखाया जाता है क्योंकि एआई अनुवाद सेटिंग्स में “मैन्युअल और चयनित अनुवादों को ओवरराइड करें” हाँ है। चुने हुए संस्करण का उपयोग करने के लिए इस सेटिंग को बंद करें।"
      },
      "manual": {
        "title": "मैन्युअल अनुवाद",
        "subtitle": "आपके द्वारा लिखा गया · स्वचालित अनुवादों पर प्राथमिकता",
        "empty": "खाली",
        "saved_but_overridden": "आपकी पसंद के रूप में सहेजा गया, लेकिन स्वचालित रूप से नहीं दिखाया जाता क्योंकि एआई अनुवाद सेटिंग्स में “मैन्युअल अनुवाद ओवरराइड करें” हाँ है: जब तक यह सेटिंग बंद नहीं की जाती, एआई से बेहतर बनाया गया अनुवाद ही दिखेगा।",
        "ignored": "स्वचालित रूप से नहीं दिखाया जाता क्योंकि एआई अनुवाद सेटिंग्स में “मैन्युअल अनुवाद ओवरराइड करें” हाँ है। इस टेक्स्ट के लिए इसे उपयोग करने हेतु इसे चुनें।",
        "label": "आपका अनुवाद",
        "placeholder": "अपना अनुवाद लिखें...",
        "last_updated": "अंतिम संपादन {{date}}",
        "save_hint": "मैन्युअल अनुवाद सहेजने से वह सक्रिय हो जाता है।",
        "delete": "मैन्युअल अनुवाद हटाएँ",
        "delete_confirm": "कृपया मैन्युअल अनुवाद हटाने की पुष्टि करें"
      }
    },
    "history": {
      "title": "एआई से बेहतर बनाए गए संस्करण",
      "subtitle": "लाइव एडिटर से किया गया हर पुनः-निर्माण सुरक्षित रखा जाता है",
      "unknown_model": "अज्ञात मॉडल",
      "current": "वर्तमान",
      "restore": "यह संस्करण पुनर्स्थापित करें",
      "restore_note": "पुनर्स्थापित करने पर वह संस्करण वर्तमान एआई से बेहतर बनाया गया अनुवाद बन जाता है। कुछ भी हटाया नहीं जाता।",
      "version_of": "संस्करण {{current}} / {{total}}",
      "hide": "इतिहास छिपाएँ ({{total}})",
      "show": "इतिहास दिखाएँ ({{total}})"
    },
    "choose": {
      "title": "{{language}} में अनुवाद · चुनें कि विज़िटर कौन-सा देखें",
      "current": "अभी आपकी वेबसाइट पर:",
      "priority": "डिफ़ॉल्ट प्राथमिकता: मैन्युअल › एआई से बेहतर › बेस। आपकी पसंद केवल इसी अनुवाद के लिए सहेजी जाती है।",
      "reset": "डिफ़ॉल्ट प्राथमिकता पर रीसेट करें",
      "reset_title": "इस टेक्स्ट के लिए आपका चुनाव हटाएँ और डिफ़ॉल्ट प्राथमिकता फिर से लागू करें",
      "resetting": "रीसेट किया जा रहा है ..."
    }
  },
  "translations": {
    "title": "अनुवाद प्रबंधन",
    "description": "आपके वेबसाइट के सभी अनुवाद सूचीबद्ध और संपादित करें, दृश्य अनुवाद के लिए लाइव संपादक का उपयोग करें",
    "filter_languages": "भाषाओं से फ़िल्टर करें...",
    "filter_original": "मूल भाषा में टेक्स्ट फ़िल्टर करें",
    "filter_translation": "अनुवादित टेक्स्ट से फ़िल्टर करें",
    "table": {
      "original": "मूल",
      "language": "भाषा",
      "action": "क्रिया",
      "base": "बेस",
      "ai": "एआई-बेहतर",
      "manual": "मैन्युअल"
    },
    "filter_exact": "सटीक मिलान",
    "badge": {
      "active": "सक्रिय",
      "overrides_manual": "मैन्युअल ओवरराइड"
    },
    "cell": {
      "none": "कोई नहीं",
      "not_generated": "तैयार नहीं",
      "ignored": "अनदेखा – एआई नियम मान्य"
    },
    "tabs": {
      "all": "सभी",
      "manual": "मैन्युअल वाले",
      "ai": "एआई-बेहतर वाले",
      "base": "केवल बेस"
    },
    "levels_hint": "हर टेक्स्ट के अधिकतम 3 स्तर होते हैं — “सक्रिय” चिह्नित स्तर ही विज़िटर को दिखता है।"
  },
  "url": {
    "main": {
      "parent": "URLs",
      "edit": "URL अनुवाद संपादित करें"
    },
    "form": {
      "original": {
        "title": "{{language}} में मूल"
      },
      "translation": {
        "title": "{{language}} में URL अनुवाद",
        "description": "URL जिसे आप ओवरराइड करना चाहते हैं",
        "placeholder": "Url अनुवाद ओवरराइड",
        "invalid_full": "आप गलत प्रारूप के साथ बदलने का प्रयास कर रहे हैं, आपको केवल URL अनुवाद के स्लग/पाथनेम बदलने चाहिए",
        "invalid": "अमान्य URL/पाथ दिया गया"
      }
    }
  },
  "urls": {
    "title": "URL प्रबंधन",
    "description": "आपके वेबसाइट के सभी URL अनुवादित सामग्री सूचीबद्ध और संपादित करें (उन्नत, 404 त्रुटियों से सावधान)",
    "filter_languages": "भाषाओं से फ़िल्टर करें...",
    "filter_original": "मूल भाषा में टेक्स्ट फ़िल्टर करें",
    "filter_translation": "अनुवादित टेक्स्ट से फ़िल्टर करें",
    "table": {
      "original": "मूल",
      "language": "भाषा",
      "url": "अनुवादित URL",
      "action": "क्रिया",
      "edited": "मूल अनुवाद संपादित किया गया है"
    }
  }
}
